/// <amd-dependency path="jqueryplugins"/>
/// <amd-dependency path="kendo"/>
define(["require", "exports", "jquery", "log", "knockout", "./tools", "./urls", "jqueryplugins", "kendo"], function (require, exports, $, log, ko, tools, urls_1) {
    "use strict";
    function pad(n) {
        return (n < 10) ? ("0".concat(n)) : n;
    }
    var Common = /** @class */ (function () {
        function Common() {
        }
        Common.init = function () {
            log.log("Initializing common module");
            Common.initUI();
            Common.checkUserLastActivity();
            $("div#message").kendoNotification({
                position: {
                    pinned: true,
                    top: 30,
                    left: 30
                },
                hideOnClick: false,
                autoHideAfter: 0,
                button: true,
                stacking: "down"
            });
            function saveFilter() {
                var globalFilter = {
                    includeDeleted: $("#chkIncludeDeletedPhoneNumber").is(":checked"),
                    includeInactive: $("#chkIncludeInactiveCustomers").is(":checked")
                };
                if (sessionStorage) {
                    sessionStorage.setItem("additionalGlobalFilter", JSON.stringify(globalFilter));
                }
            }
            function restoreFilter() {
                if (sessionStorage) {
                    var globalFilterStr = sessionStorage.getItem("additionalGlobalFilter");
                    if (globalFilterStr) {
                        var globalFilter = JSON.parse(globalFilterStr);
                        $("#chkIncludeDeletedPhoneNumber").prop("checked", globalFilter.includeDeleted);
                        $("#chkIncludeInactiveCustomers").prop("checked", globalFilter.includeInactive);
                    }
                }
                updateFilterClass();
            }
            function updateFilterClass() {
                if ($("#chkIncludeDeletedPhoneNumber").is(":checked") || $("#chkIncludeInactiveCustomers").is(":checked")) {
                    $(".open-filter-settings").addClass("active");
                }
                else {
                    $(".open-filter-settings").removeClass("active");
                }
            }
            restoreFilter();
            $("#chkIncludeDeletedPhoneNumber, #chkIncludeInactiveCustomers").on("click", function (event) {
                log.log(event.currentTarget);
                saveFilter();
                updateFilterClass();
            });
            var navSearchInput = $("#nav-search-input");
            navSearchInput.on("keyup", function () {
                var inputNumber = navSearchInput.val();
                var containsPatt = /[a-zA-Z]/i;
                var patt = containsPatt.test(inputNumber) ? /[]/g : /[-+(). ]/g;
                if (patt.test(inputNumber)) {
                    inputNumber = inputNumber.replace(patt, "");
                    navSearchInput.val(inputNumber);
                    navSearchInput.trigger("change");
                }
            });
            function getCleanNumber() {
                var inputNumber = navSearchInput.val();
                var containsPatt = /[a-zA-Z]/i;
                var patt = containsPatt.test(inputNumber) ? /[]/g : /[-+(). ]/g;
                inputNumber = inputNumber.replace(patt, "");
                return inputNumber;
            }
            $(document).on("click", function (event) {
                if ((!$(event.target).hasClass("open-filter-settings") && !$(event.target).parent().hasClass("open-filter-settings") && !$(event.target).parent().parent().hasClass("open-filter-settings"))
                    && (!$(event.target).hasClass("global-filter-toggle")) && !$(event.target).parent().hasClass("global-filter-toggle") && !$(event.target).parent().parent().hasClass("global-filter-toggle")) {
                    if ($(".global-filter-toggle").is(":visible")) {
                        $(".global-filter-toggle").slideToggle();
                    }
                }
                var settingsButton = $("#ace-settings-btn");
                if (settingsButton
                    && !$(event.target).hasClass("ace-settings-btn")
                    && !$(event.target).parent().hasClass("ace-settings-btn")
                    && !$(event.target).hasClass("ace-settings-box")
                    && !$(event.target).parent().hasClass("ace-settings-box")
                    && !$(event.target).parent().hasClass("ace-settings-box")
                    && !$(event.target).parent().parent().hasClass("ace-settings-box")
                    && !$(event.target).parent().parent().parent().hasClass("ace-settings-box")
                    && !$(event.target).parent().parent().parent().parent().hasClass("ace-settings-box")
                    && !$(settingsButton).hasClass("open")) {
                    settingsButton.click();
                }
            });
            $(".open-filter-settings").on("click", function () {
                $(".global-filter-toggle").slideToggle();
            });
            navSearchInput.kendoAutoComplete({
                dataTextField: "Suggestion",
                dataSource: {
                    transport: {
                        read: {
                            url: "/Customers/GlobalSearch",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.phoneNumber = getCleanNumber();
                                data.includeDeleted = $("#chkIncludeDeletedPhoneNumber").is(":checked");
                                data.includeInactive = $("#chkIncludeInactiveCustomers").is(":checked");
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        data: function (response) { return response.Data; },
                        total: "Total"
                    },
                    serverFiltering: true,
                    group: { field: "Type" }
                },
                select: function (e) {
                    var item = e.dataItem;
                    if (item.ParentId) {
                        window.location.assign("/Customers/Edit/" + item.ParentId);
                    }
                    else {
                        window.location.assign("/PhoneNumbers/Details/" + item.Id);
                    }
                }
            });
        };
        Common.initUI = function () {
            Common.initMenu();
            Common.initReportsMenu();
            Common.initSecondaryMenu();
            Common.initSettingsMenu();
            Common.makePageSizeSelected();
        };
        Common.getParameterByName = function (name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"), results = regex.exec(location.search);
            return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        };
        Common.makePageSizeSelected = function () {
            var pageSize = Common.getParameterByName("pageSize");
            if (pageSize) {
                $("#ddlPageSize").val(pageSize);
            }
        };
        Common.initMenu = function () {
            //active items highlight
            var url = window.location;
            var links = $("ul.nav a").filter(function (index, elem) {
                return elem.href === url.href;
            }).parent();
            if (links.parent().hasClass("submenu")) {
                links.parent().addClass("nav-show");
                links.parent().removeClass("nav-hide");
                links.parent().show();
                links.parent().parent().addClass("open");
            }
            links.addClass("active");
            log.log("initialize menu");
        };
        Common.initReportsMenu = function () {
            //active items highlight
            var currentUrl = window.location.pathname;
            var currectPageUrl = currentUrl; //currectPageUrlList[currectPageUrlList.length - 1];
            var currentLi = $('.sidebar__nav').find('[href="' + currectPageUrl + '"]').parent('li');
            currentLi.addClass('active');
            currentLi.closest('.sidebar-nav__dropdown').addClass("active");
            currentLi.closest('.collapse').collapse('toggle');
            log.log("initialize reports menu");
        };
        Common.initSecondaryMenu = function () {
            var menuItems = $(".secondary-menu ul.second-navbar-nav > li").filter(function (index, elem) {
                return !$(elem).hasClass("more-menu");
            });
            $(".more-menu .dropdown-menu").append(menuItems.clone());
            Common.updateSecondaryMenu();
            var resizeRunner = 0;
            $(window).resize(function () {
                if (resizeRunner) {
                    clearTimeout(resizeRunner);
                }
                resizeRunner = setTimeout(function () {
                    Common.updateSecondaryMenu();
                }, 100);
            });
            $(".second-navbar").css("visibility", "visible");
            log.log("initialize secondary menu");
        };
        Common.initSettingsMenu = function () {
            $("#ace-settings-filter-row").on("click", function (event) {
                var gridId = $(event.currentTarget).closest(".grid-settings-holder").data("id");
                if ($("#ace-settings-filter-row").prop('checked')) {
                    $("#ace-settings-filter-menu").prop('checked', true);
                }
                Common.updateGridSettings(gridId);
            });
            $("#ace-settings-filter-menu").on("click", function (event) {
                var gridId = $(event.currentTarget).closest(".grid-settings-holder").data("id");
                Common.updateGridSettings(gridId);
            });
            $("#savePageSettings").on("click", function (event) {
                event.preventDefault();
                var settingsButton = $("#ace-settings-btn");
                if (settingsButton) {
                    settingsButton.click();
                }
                var settingsStr = localStorage["user-settings"];
                var settings = settingsStr ? JSON.parse(settingsStr) : {};
                settings["menuOnHover"] = $("#ace-settings-hover").prop('checked');
                settings["compactMenu"] = $("#ace-settings-compact").prop('checked');
                var gridsSettings = settings["gridsSettings"] || {};
                $(".grid-settings-holder").each(function (index, elm) {
                    //ace-settings-grid
                    var shouldSaveSettings = $("#ace-settings-grid", elm).prop('checked');
                    var gridIds = $(elm).data("id").split(',');
                    if (shouldSaveSettings) {
                        console.log('save grid settings');
                        for (var _i = 0, gridIds_1 = gridIds; _i < gridIds_1.length; _i++) {
                            var gridId = gridIds_1[_i];
                            var grid = $("#".concat(gridId)).data("kendoGrid");
                            if (grid) {
                                gridsSettings[gridId] = {
                                    options: grid.getOptions(),
                                    pageSize: grid.dataSource.pageSize()
                                };
                                delete gridsSettings[gridId].options.toolbar;
                            }
                        }
                    }
                    else {
                        for (var _a = 0, gridIds_2 = gridIds; _a < gridIds_2.length; _a++) {
                            var gridId = gridIds_2[_a];
                            gridsSettings[gridId] = {
                                shouldSave: shouldSaveSettings
                            };
                        }
                    }
                });
                settings["gridsSettings"] = gridsSettings;
                localStorage["user-settings"] = kendo.stringify(settings);
            });
            //update global settings
            var settingsStr = localStorage["user-settings"];
            var settings = settingsStr ? JSON.parse(settingsStr) : {};
            var gridsSettings = settings["gridsSettings"] || {};
            if (settings["menuOnHover"]) {
                $("#ace-settings-hover").click();
            }
            if (settings["compactMenu"]) {
                $("#ace-settings-compact").click();
            }
            $(".grid-settings-holder").each(function (index, elm) {
                var gridIds = $(elm).data("id").split(',');
                for (var _i = 0, gridIds_3 = gridIds; _i < gridIds_3.length; _i++) {
                    var gridId = gridIds_3[_i];
                    $("#ace-settings-grid", elm).prop('checked', false);
                    var gridSettings = gridsSettings[gridId];
                    if (gridSettings && gridSettings.options) {
                        $("#ace-settings-grid", elm).prop('checked', true);
                        $("#ace-settings-filter-row", elm).prop('checked', gridSettings.options.filterable ? gridSettings.options.filterable.mode.indexOf("row") >= 0 : false);
                        $("#ace-settings-filter-menu", elm).prop('checked', gridSettings.options.filterable ? gridSettings.options.filterable.mode.indexOf("menu") >= 0 : false);
                        break;
                    }
                }
            });
        };
        Common.getGridSettings = function (gridId) {
            var settingsStr = localStorage["user-settings"];
            var settings = settingsStr ? JSON.parse(settingsStr) : {};
            var gridsSettings = settings["gridsSettings"] || {};
            return gridsSettings[gridId] ? gridsSettings[gridId].options : null;
        };
        Common.updateGridSettings = function (gridId) {
            var filterRow = $("#ace-settings-filter-row").prop('checked');
            var filterMenu = $("#ace-settings-filter-menu").prop('checked');
            var grid = $("#".concat(gridId)).data("kendoGrid");
            if (filterRow || filterMenu) {
                var mode = "";
                if (filterRow) {
                    mode += "row";
                }
                if (filterMenu) {
                    mode += " menu";
                }
                grid.setOptions({
                    filterable: {
                        mode: mode,
                        extra: false
                    }
                });
            }
            else {
                grid.setOptions({
                    filterable: false
                });
            }
            $("#".concat(gridId)).trigger("reinit");
        };
        Common.updateSecondaryMenu = function () {
            var containerWidth = $(".secondary-menu").outerWidth(true);
            var moreMenuWidth = 100;
            var usedWidth = moreMenuWidth;
            var shouldShowMore = false;
            $(".secondary-menu ul.second-navbar-nav > li").each(function (index, elem) {
                var menuItemWidth = $(elem).outerWidth(true);
                usedWidth += menuItemWidth;
                var dropDownMenuItem = $(".more-menu .dropdown-menu li").get(index);
                if ($(elem).hasClass("more-menu")) {
                    shouldShowMore ? $(elem).show() : $(elem).hide();
                    return;
                }
                if (usedWidth > containerWidth) { //hide menu item
                    $(elem).hide();
                    $(dropDownMenuItem).show();
                    shouldShowMore = true;
                }
                else {
                    $(elem).show();
                    $(dropDownMenuItem).hide();
                }
            });
        };
        Common.getTimeRemaining = function (endtime) {
            var t = Date.parse(endtime) - Date.now();
            var seconds = Math.floor((t / 1000) % 60);
            var minutes = Math.floor((t / 1000 / 60) % 60);
            var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
            var days = Math.floor(t / (1000 * 60 * 60 * 24));
            return {
                'total': t,
                'days': days > 0 ? days : 0,
                'hours': hours > 0 ? hours : 0,
                'minutes': minutes > 0 ? minutes : 0,
                'seconds': seconds > 0 ? seconds : 0
            };
        };
        Common.initializeClock = function (id, modalId, endtime) {
            var clock = document.getElementById(id);
            var modalClock = document.getElementById(modalId);
            Common.counterInterval = setInterval(function () {
                var t = Common.getTimeRemaining(endtime);
                var time = pad(t.hours) + ":" + pad(t.minutes) + ":" + pad(t.seconds);
                clock.innerHTML = time;
                if (modalClock) {
                    modalClock.innerHTML = time;
                }
                if (t.total <= 0) {
                    clearInterval(Common.counterInterval);
                    window.location.assign("/Account/LogOff?LogOff=autoLogOff");
                }
                if (t.total < 5 * 60 * 1000) {
                    if (!Common.sessionExpireModal) {
                        Common.sessionExpireModal = tools.editModal({
                            title: "Your Session will expire soon",
                            buttonTitle: "Logout",
                            cancelButtonTitle: "Continue",
                            type: "warning",
                            loadingText: "Logging out...",
                            modalOptions: {},
                            close: function (modal) {
                                Common.sessionExpireModal = null;
                            },
                            cancel: function (event, modal) {
                                tools.ajaxGet({
                                    url: "/AutoLogOutCheck/checkUserIdleLoginTime",
                                    //headers: { "x-keep-same-time": "false" },
                                    global: false,
                                    success: function (data) {
                                        if (data.Success) {
                                            clearInterval(Common.counterInterval);
                                            Common.initializeClock("sessionCounter", "modalSessionCounter", data.Data);
                                        }
                                        else {
                                            window.location.assign("/Account/LogOff?LogOff=autoLogOff");
                                        }
                                    }
                                }).always(function () {
                                    setTimeout(function () {
                                        Common.checkUserLastActivity();
                                    }, 10000);
                                });
                            },
                            save: function (event, modal) {
                                $(event.currentTarget).button("loading");
                                setTimeout(function () {
                                    window.location.assign("/Account/LogOff?LogOff=autoLogOff");
                                }, 100);
                            },
                            opened: function (modal) {
                                $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'session-expire-template', data: {} }\"></div>");
                                ko.applyBindings(self, modal);
                                modalClock = document.getElementById(modalId);
                                if (modalClock) {
                                    modalClock.innerHTML = time;
                                }
                            }
                        });
                    }
                }
                else {
                    if (Common.sessionExpireModal) {
                        $(Common.sessionExpireModal).modal("hide");
                        Common.sessionExpireModal = null;
                    }
                }
            }, 1000);
        };
        Common.checkUserLastActivity = function () {
            if (!urls_1.urls.startsWith("/Account/Login")
                && !urls_1.urls.startsWith("/Account/Register")
                && !urls_1.urls.startsWith("/Account/ForgotPassword")
                && !urls_1.urls.startsWith("/Account/ResetPassword")) {
                tools.ajaxGet({
                    url: "/AutoLogOutCheck/checkUserIdleLoginTime",
                    headers: { "x-keep-same-time": "true" },
                    global: false,
                    success: function (data) {
                        if (data.Success) {
                            clearInterval(Common.counterInterval);
                            Common.initializeClock("sessionCounter", "modalSessionCounter", data.Data);
                        }
                        else {
                            window.location.assign("/Account/LogOff?LogOff=autoLogOff");
                        }
                    }
                }).always(function () {
                    setTimeout(function () {
                        Common.checkUserLastActivity();
                    }, 10000);
                });
            }
        };
        Common.counterInterval = 0;
        return Common;
    }());
    $(function () {
        Common.init();
    });
    return Common;
});
//# sourceMappingURL=common.js.map


//////////////////
// WEBPACK FOOTER
// ./build/utils/common.js
// module id = 277
// module chunks = 2